import { compose, withHandlers } from 'recompose';
import withToggle from '../../../common/hoc/withToggle';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';

const PurchaseOrdersNavigationContainer = compose(
  withToggle('opened', false),
  connect(state => ({
    title: state.products.poTitle,
  })),
  withHandlers({
    handleClickOutside: props => () => props.openedOff(),
  }),
  onClickOutside,
);

export default PurchaseOrdersNavigationContainer;
